"use client";

import React from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToStart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="239691" id="ready-to-start" className="dark bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-4xl mx-auto" ref={ref}>
        <Card className={`relative overflow-hidden border-primary/10 bg-primary/5 backdrop-blur-md shadow-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-secondary to-transparent opacity-40" />
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-secondary/5 rounded-lg blur-3xl pointer-events-none animate-pulse" />
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-secondary/5 rounded-lg blur-3xl pointer-events-none animate-pulse" />

          <CardContent className="p-8 md:p-16 text-center flex flex-col items-center gap-6 relative z-10">
            <div className="w-16 h-16 rounded-md bg-secondary/20 flex items-center justify-center mb-2 rotate-0 transition-transform hover:scale-110">
              <BookOpen className="w-8 h-8 text-secondary" />
            </div>
            
            <div className="space-y-4 max-w-2xl">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tighter text-foreground">
                Ready to Start?
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
                Take the first step toward your new home with Beacon Finance Group. Our digital application is designed for speed, security, and absolute clarity.
              </p>
            </div>

            <div className="mt-6">
              <Button asChild size="lg" className="rounded-md px-8 h-12 text-base font-semibold bg-secondary text-secondary-foreground hover:bg-secondary/90 group">
                <Link to="/ContactPage">
                  Begin Digital Application
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}